(function () {
  var RATE_CACHE_KEY = 'currency-toggle-rate';
  var RATE_CACHE_MS = 60 * 60 * 1000; // 1 hora
  var MODE_KEY = 'currency-toggle-mode';
  var FLAGS = { USD: '🇺🇸', UYU: '🇺🇾' };

  function getSavedMode() {
    return localStorage.getItem(MODE_KEY) || 'UYU';
  }

  function saveMode(mode) {
    localStorage.setItem(MODE_KEY, mode);
  }

  function getCachedRate() {
    try {
      var raw = localStorage.getItem(RATE_CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (Date.now() - data.ts > RATE_CACHE_MS) return null;
      return data.venta;
    } catch (e) {
      return null;
    }
  }

  function fetchRate() {
    var cached = getCachedRate();
    if (cached) return Promise.resolve(cached);
    return fetch('https://uy.dolarapi.com/v1/cotizaciones/usd')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var venta = data && data.venta ? data.venta : null;
        if (venta) {
          localStorage.setItem(RATE_CACHE_KEY, JSON.stringify({ venta: venta, ts: Date.now() }));
        }
        return venta;
      })
      .catch(function () { return null; });
  }

  function parseUyuAmount(text) {
    // Formato uruguayo: punto = separador de miles, coma = decimales.
    // Ej: "$ 1.990,00 UYU" -> se debe interpretar como 1990.00, no 1.99
    var match = text.match(/[\d.,]+/);
    if (!match) return null;
    var raw = match[0]
      .replace(/\./g, '')   // saca los puntos de miles
      .replace(',', '.');   // la coma decimal pasa a ser el punto real
    var value = parseFloat(raw);
    return isNaN(value) ? null : value;
  }

  function formatUsd(amount) {
    var formatted = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
    return '$ ' + formatted + ' USD';
  }

  function applyMode(mode, rate) {
    document.querySelectorAll('.price-item').forEach(function (el) {
      if (!el.dataset.uyuText) {
        el.dataset.uyuText = el.textContent.trim();
      }
      if (mode === 'USD' && rate) {
        var uyu = parseUyuAmount(el.dataset.uyuText);
        if (uyu !== null) {
          el.textContent = formatUsd(uyu / rate);
        }
      } else {
        el.textContent = el.dataset.uyuText;
      }
    });
  }

  function updateButtons(mode) {
    document.querySelectorAll('.currency-toggle__btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.currency === mode);
    });
    document.querySelectorAll('.currency-toggle__current').forEach(function (btn) {
      var flagEl = btn.querySelector('.currency-toggle__flag');
      var codeEl = btn.querySelector('.currency-toggle__code');
      if (flagEl) flagEl.textContent = FLAGS[mode];
      if (codeEl) codeEl.textContent = mode;
    });
  }

  function closeAllDropdowns() {
    document.querySelectorAll('.currency-toggle.is-open').forEach(function (el) {
      el.classList.remove('is-open');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var mode = getSavedMode();
    var currentRate = null;

    updateButtons(mode);

    fetchRate().then(function (rate) {
      currentRate = rate;
      if (rate) applyMode(mode, rate);
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.currency-toggle__current');
      if (trigger) {
        var wrap = trigger.closest('.currency-toggle');
        var wasOpen = wrap.classList.contains('is-open');
        closeAllDropdowns();
        if (!wasOpen) wrap.classList.add('is-open');
        return;
      }

      var btn = e.target.closest('.currency-toggle__btn');
      if (btn) {
        mode = btn.dataset.currency;
        saveMode(mode);
        updateButtons(mode);
        closeAllDropdowns();
        if (currentRate) applyMode(mode, currentRate);
        return;
      }

      if (!e.target.closest('.currency-toggle')) {
        closeAllDropdowns();
      }
    });

    var observer = new MutationObserver(function (mutations) {
      var hasNewPrices = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && (n.matches?.('.price-item') || n.querySelector?.('.price-item'));
        });
      });
      if (hasNewPrices && currentRate) {
        applyMode(mode, currentRate);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('cart:refresh', function () {
      if (currentRate) setTimeout(function () { applyMode(mode, currentRate); }, 50);
    });
  });
})();